export const CARGO_ROWS = [["F", "Przód"], ["M", "Środek"], ["B", "Tył"]];
export const CARGO_COLS = [["L", "lewa"], ["C", "środek"], ["R", "prawa"]];
const EXTRA = { cab: "Kabina", side: "Drzwi boczne" };

export const BAG_COLORS = {
  red: { label: "czerwona", hex: "#dc2626" }, blue: { label: "niebieska", hex: "#2563eb" },
  green: { label: "zielona", hex: "#16a34a" }, yellow: { label: "żółta", hex: "#facc15" },
  orange: { label: "pomarańczowa", hex: "#f97316" }, purple: { label: "fioletowa", hex: "#9333ea" },
  pink: { label: "różowa", hex: "#ec4899" }, black: { label: "czarna", hex: "#18181b" },
  white: { label: "biała", hex: "#ffffff" }, gray: { label: "szara", hex: "#71717a" },
};
export const bagLabel = (bag) => `Big bag ${bag.number} · ${BAG_COLORS[bag.color]?.label || bag.color}`;
export const bagHex = (bag) => BAG_COLORS[bag?.color]?.hex || "#a1a1aa";

// `bag` = the bag object for "bag:<id>" codes (from the draft's bag list or the stop snapshot).
export const slotLabel = (code, bag) => {
  if (!code) return "";
  if (code.startsWith("bag:")) return bag ? bagLabel(bag) : "Big bag";
  if (EXTRA[code]) return EXTRA[code];
  const [row, col] = code.split("-");
  const r = CARGO_ROWS.find(([k]) => k === row);
  const c = CARGO_COLS.find(([k]) => k === col);
  return r && c ? `${r[1]} · ${c[1]}` : code;
};
export const findBag = (code, bags = []) => (code?.startsWith("bag:") ? bags.find((b) => `bag:${b.id}` === code) : null);

export const fold = (value) => String(value || "").toLowerCase().replace(/ł/g, "l").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const plural = (n, one, few, many) => {
  if (n === 1) return `${n} ${one}`;
  const d = n % 10, t = n % 100;
  return `${n} ${d >= 2 && d <= 4 && (t < 12 || t > 14) ? few : many}`;
};

export const money = (v) => Number(v).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
